export class SharedPersistenceKey {
  static readonly EMPLOYEE = 'shared/persistence/employee';
  static readonly YEAR = 'shared/persistence/year';
  static readonly MONTH = 'shared/persistence/month';
}
